<template>
  <v-avatar color="black">
    <img
      v-if="user.Profile && user.Profile.AvatarUrl"
      :src="user.Profile.AvatarUrl"
      :alt="`avatar-${user.Profile.Name}`"
    >
    <span
      v-else
      class="white--text"
    >{{user.Profile && user.Profile.Name && user.Profile.Name.substr(0,1)}}</span>
  </v-avatar>
</template>

<script>
export default {
  props: {
    user: {
      type: Object,
      required: true
    }
  }
};
</script>